// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { withLocalization } from 'bernie-l10n';

// ui
import { UitkSpacing } from 'uitk-react-spacing';

// components
import { Benefits } from './benefits';
import { Intro } from './intro';
import { Outro } from './outro';
import { Tools } from './tools';
import { LocalizedComponentProps } from '@shared-ui/localization-context';
import { ContextStore } from 'bernie-core';

export interface HomeProps extends LocalizedComponentProps {
  context?: ContextStore;
}

@withLocalization
@inject('context')
export class Home extends React.Component<HomeProps> {
  public render() {
    return (
      <>
        <UitkSpacing padding={{ block: 'twelve' }}>
          <section>
            <div className="container">
              <Intro locale={this.props.context.locale} />
            </div>
          </section>
        </UitkSpacing>

        <UitkSpacing className="lp-section-bg" padding={{ block: 'twelve' }}>
          <section>
            <div className="container">
              <Benefits locale={this.props.context.locale} />
            </div>
          </section>
        </UitkSpacing>

        <UitkSpacing padding={{ block: 'twelve' }}>
          <section>
            <div className="container">
              <Tools />
            </div>
          </section>
        </UitkSpacing>

        <UitkSpacing className="lp-section-bg" padding={{ block: 'twelve' }}>
          <section>
            <div className="container">
              <Outro locale={this.props.context.locale} />
            </div>
          </section>
        </UitkSpacing>
      </>
    );
  }
}
